import React from 'react';

import extensions from 'constants/extensions'

import iconMapping from './iconMapping';

import './index.css'


class FileIcon extends React.Component {
	renderIcon = (item = '', isFolder, size) => {
    let component = null;
    let ext = item.split('.').pop();

    let sizeNumber = 16;

    if (size === 'medium') {
      sizeNumber = 24;
    } else if (size === 'large') {
      sizeNumber = 48;
    }

    if (isFolder) {
      component = iconMapping.Folder(sizeNumber);
    } else if (this.isImage(ext)) {
      component = iconMapping.Image(sizeNumber);
    } else if (this.isVideo(ext)) {
      component = iconMapping.Video(sizeNumber);
    } else if (this.isAudio(ext)) {
      component = iconMapping.Audio(sizeNumber);
    } else if (this.isCode(ext)) {
      component = iconMapping.SourceCode(sizeNumber);
    } else if (this.specialFile(ext, sizeNumber)) {
      component = this.specialFile(ext, sizeNumber);
    } else {
      component = iconMapping.Generic(sizeNumber);
    }

    return (
      <span className={'file-icon'}>{component}</span>
    );

  };

  isImage = (ext = '') => {
    return extensions.image.includes(ext.toLowerCase())
  };

  isVideo = (ext) => {
    return extensions.video.includes(ext.toLowerCase())
  };

  isAudio = (ext) => {
    return extensions.audio.includes(ext.toLowerCase())
  };

  isCode = (ext) => {
    return extensions.code.includes(ext.toLowerCase())
  };

  specialFile = (ext, sizeNumber) =>  {
    const extensions = {
      'csv': iconMapping.ExcelSpreadsheet(sizeNumber),
      'docx': iconMapping.WordDocument(sizeNumber),
      'doc': iconMapping.WordDocument(sizeNumber),
      'gif': iconMapping.Gif(sizeNumber),
      'ipa': iconMapping.Executable(sizeNumber),
      'xlsx': iconMapping.ExcelSpreadsheet(sizeNumber),
      'pdf': iconMapping.PdfDocument(sizeNumber),
      'pptx': iconMapping.PowerpointPresentation(sizeNumber),
      'sketch': iconMapping.Sketch(sizeNumber),
      'zip': iconMapping.Archive(sizeNumber),
      'gz': iconMapping.Archive(sizeNumber),
    };

    return extensions[ext.toLowerCase()];
  };

	render() {
    const { item, is_dir, size = 'small' } = this.props;

		return this.renderIcon(item, is_dir, size);
	}
}

export default FileIcon;